/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './treatment-cycle.reducer';

export const TreatmentCycleDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const treatmentCycleEntity = useAppSelector(state => state.treatmentCycle.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="treatmentCycleDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.treatmentCycle.detail.title">TreatmentCycle</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.treatmentCycle.id">Id</Translate>
            </span>
          </dt>
          <dd>{treatmentCycleEntity.id}</dd>
          <dt>
            <span id="cycleNumber">
              <Translate contentKey="tinyMedicRestApp.treatmentCycle.cycleNumber">Cycle Number</Translate>
            </span>
          </dt>
          <dd>{treatmentCycleEntity.cycleNumber}</dd>
          <dt>
            <span id="startDate">
              <Translate contentKey="tinyMedicRestApp.treatmentCycle.startDate">Start Date</Translate>
            </span>
          </dt>
          <dd>{treatmentCycleEntity.startDate}</dd>
          <dt>
            <span id="endDate">
              <Translate contentKey="tinyMedicRestApp.treatmentCycle.endDate">End Date</Translate>
            </span>
          </dt>
          <dd>{treatmentCycleEntity.endDate}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="tinyMedicRestApp.treatmentCycle.status">Status</Translate>
            </span>
          </dt>
          <dd>{treatmentCycleEntity.status}</dd>
          <dt>
            <span id="hasChemoPort">
              <Translate contentKey="tinyMedicRestApp.treatmentCycle.hasChemoPort">Has Chemo Port</Translate>
            </span>
          </dt>
          <dd>{treatmentCycleEntity.hasChemoPort ? 'true' : 'false'}</dd>
          <dt>
            <span id="catheterSite">
              <Translate contentKey="tinyMedicRestApp.treatmentCycle.catheterSite">Catheter Site</Translate>
            </span>
          </dt>
          <dd>{treatmentCycleEntity.catheterSite}</dd>
          <dt>
            <span id="gauge">
              <Translate contentKey="tinyMedicRestApp.treatmentCycle.gauge">Gauge</Translate>
            </span>
          </dt>
          <dd>{treatmentCycleEntity.gauge}</dd>
          <dt>
            <span id="noOfAttempts">
              <Translate contentKey="tinyMedicRestApp.treatmentCycle.noOfAttempts">No Of Attempts</Translate>
            </span>
          </dt>
          <dd>{treatmentCycleEntity.noOfAttempts}</dd>
          <dt>
            <span id="difficultIV">
              <Translate contentKey="tinyMedicRestApp.treatmentCycle.difficultIV">Difficult IV</Translate>
            </span>
          </dt>
          <dd>{treatmentCycleEntity.difficultIV ? 'true' : 'false'}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.treatmentCycle.active">Active</Translate>
            </span>
          </dt>
          <dd>{treatmentCycleEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.treatmentCycle.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{treatmentCycleEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.treatmentCycle.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{treatmentCycleEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.treatmentCycle.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{treatmentCycleEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.treatmentCycle.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{treatmentCycleEntity.timestampEntry}</dd>
          <dt>
            <span id="notes">
              <Translate contentKey="tinyMedicRestApp.treatmentCycle.notes">Notes</Translate>
            </span>
          </dt>
          <dd>{treatmentCycleEntity.notes}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentCycle.cycle">Cycle</Translate>
          </dt>
          <dd>{treatmentCycleEntity.cycle ? treatmentCycleEntity.cycle.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentCycle.vitals">Vitals</Translate>
          </dt>
          <dd>{treatmentCycleEntity.vitals ? treatmentCycleEntity.vitals.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentCycle.regimen">Regimen</Translate>
          </dt>
          <dd>{treatmentCycleEntity.regimen ? treatmentCycleEntity.regimen.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/treatment-cycle" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/treatment-cycle/${treatmentCycleEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TreatmentCycleDetail;
